import { render, staticRenderFns } from "./ImportTicket.vue?vue&type=template&id=33fa4891&scoped=true&"
import script from "./ImportTicket.vue?vue&type=script&lang=js&"
export * from "./ImportTicket.vue?vue&type=script&lang=js&"
import style0 from "./ImportTicket.vue?vue&type=style&index=0&id=33fa4891&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fa4891",
  null
  
)

export default component.exports